import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, BCMSDate } from "@bcm-dev/bcms-vite";
import OneTimeACHPaymentPage, { getDefaultData } from "components/pages/OneTimeACHPaymentPage";
import Classes from "model";

export default function CaptureTransferTypeSelected(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const { state } = context ?? {};
    const { branding } = state ?? {};
    const { options } = branding ?? {};
    const hasImmediateOption = options.onetimeach_immediate_abi22 === "true";
    const hasOneTimeSameDay = options.onetimeach_same_day_abi22 === "true";
    const scheduleType = hasImmediateOption ? "immediate" : hasOneTimeSameDay ? "same day" : "future dated";
    const effectiveDate = hasImmediateOption ? BCMSDate.init().nextBusinessDay() : hasOneTimeSameDay ? BCMSDate.init() : BCMSDate.init().nextBusinessDay();
    
    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "oneTimeACHPayment", "transactionType" ], "payment")
    .update(["oneTimeACHPayment", "scheduleType"], scheduleType)
    .update(["oneTimeACHPayment", "effectiveDate"], effectiveDate)
    .submit();

    return <OneTimeACHPaymentPage data={ data } />;
}